import { render } from "./Profil.vue?vue&type=template&id=21a91038&scoped=true&ts=true"
import script from "./Profil.vue?vue&type=script&lang=ts"
export * from "./Profil.vue?vue&type=script&lang=ts"

import "./Profil.vue?vue&type=style&index=0&id=21a91038&lang=scss&scoped=true"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a91038"]])

export default __exports__